import http from "./http-common";
import { AppConfig } from "../configs/app.config";

class ApiService {
  options = {
    headers: {
      Authorization: "",
    },
  };

  profile: any = null;

  constructor() {
    if (localStorage.getItem("auth")) {
      const auth = JSON.parse(localStorage.getItem("auth") || "");
      this.options.headers.Authorization = `Bearer ${auth?.idToken}`;
    }
    if (localStorage.getItem("profile")) {
      this.profile = JSON.parse(localStorage.getItem("profile") || "");
    }
  }

  login() {
    return http.get(`${AppConfig.apiBaseURL}/auth/admin/login`);
  }

  search(request: SearchRequest) {
    return http.post(
      `${AppConfig.apiBaseURL}/v2/search`,
      request,
      this.options
    );
  }

  acquireToken(code: string) {
    const request = {
      code,
    };
    return http.post(
      `${AppConfig.apiBaseURL}/auth/authorization-code/callback/v2`,
      request
    );
  }

  updateMailJetContacts() {
    return http.get(
      `${AppConfig.apiBaseURL}/v2/mailjet/contact/managemanycontacts`,
      this.options
    );
  }

  changePassword(request: any) {
    return http.post(
      `${AppConfig.apiBaseURL}/auth/change-password`,
      request,
      this.options
    );
  }

  getDashboard() {
    return http.get(`${AppConfig.apiBaseURL}/dashboard`, this.options);
  }

  getActivePractices() {
    return http.get(
      `${AppConfig.apiBaseURL}/dashboard/customers`,
      this.options
    );
  }

  getPractices(
    page: any,
    pageSize: any,
    sortField: any,
    sortOrder: any,
    searchQuery = ""
  ) {
    let payload = {
      pagination: {
        page: page,
        limit: pageSize,
      },
      sort: {
        [sortField]: sortOrder,
      },
      search: searchQuery,
    };
    return http.post(
      `${AppConfig.apiBaseURL}/medical-practice/all`,
      payload,
      this.options
    );
  }
  getCancelledSurvey(
    page: any,
    pageSize: any,
    sortField: any,
    sortOrder: any,
    filter = 0,
    searchQuery = ""
  ) {
    let payload = {
      pagination: {
        page: page,
        limit: pageSize,
      },
      sort: {
        [sortField]: sortOrder,
      },
      filters: {
        medicalPracticeId: filter,
      },
      search: searchQuery,
    };
    return http.post(
      `${AppConfig.apiBaseURL}/scheduling/get/cancel-survey`,
      payload,
      this.options
    );
  }

  getProfiles(
    page: any,
    pageSize: any,
    sortField: any,
    sortOrder: any,
    filter = 0,
    searchQuery = ""
  ) {
    let payload;
    if (filter !== 0) {
      payload = {
        pagination: {
          page: page,
          limit: pageSize,
        },
        sort: {
          [sortField]: sortOrder,
        },
        filters: {
          medicalPracticeId: filter,
        },
        search: searchQuery,
      };
    } else {
      payload = {
        pagination: {
          page: page,
          limit: pageSize,
        },
        sort: {
          [sortField]: sortOrder,
        },
        search: searchQuery,
      };
    }

    return http.post(
      `${AppConfig.apiBaseURL}/profile/all`,
      payload,
      this.options
    );
  }

  toggleAccess(profileId: number) {
    return http.put(`${AppConfig.apiBaseURL}/profile/access/toggle-role`, {
      profileId,
    });
  }

  getProfile() {
    if (localStorage.getItem("auth")) {
      const auth = JSON.parse(localStorage.getItem("auth") || "");
      this.options.headers.Authorization = `Bearer ${auth?.idToken}`;
    }
    return http.get(`${AppConfig.apiBaseURL}/profile/me`, this.options);
  }

  getExcelData(range: any, duration: any) {
    console.log("this.options", this.options);
    let option = {
      range: range,
      duration: duration,
    };
    return http.post(
      `${AppConfig.apiBaseURL}/medical-practice/report/`,
      option,
      this.options
    );
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ApiService();
